module.exports = __webpack_public_path__ + "static/media/David_tien1.236a73eb.jpg";